import script from "./UpComplemento.vue?vue&type=script&lang=ts&setup=true"
export * from "./UpComplemento.vue?vue&type=script&lang=ts&setup=true"

import "./UpComplemento.vue?vue&type=style&index=0&id=6adc4472&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6adc4472"]])

export default __exports__